/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Pw_FineprintInputs */

const en_funnel_pw_fineprint = /** @type {(inputs: Funnel_Pw_FineprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel in one tap`)
};

const es_funnel_pw_fineprint = /** @type {(inputs: Funnel_Pw_FineprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancela con un toque`)
};

/**
* | output |
* | --- |
* | "Cancel in one tap" |
*
* @param {Funnel_Pw_FineprintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_pw_fineprint = /** @type {((inputs?: Funnel_Pw_FineprintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Pw_FineprintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_pw_fineprint(inputs)
	return en_funnel_pw_fineprint(inputs)
});